import containerFuild from '../html-snippets/container-fuild.js';
import css from '../css-snippets/section-furnitureshop-banner-03.js';

const featureIcon = 'https://cdn.skyfastimg.com/images/2026/08/24/image-6a8bc86498460bd495d50d46.png?w=200';

const featureItem = text => `
  <li class="furnitureshop-banner-03__feature" data-attribute="furnitureshop-banner-03__feature">
    <img
      class="furnitureshop-banner-03__feature-icon"
      data-attribute="furnitureshop-banner-03__feature-icon"
      src="${featureIcon}"
      alt=""
    />
    <span
      class="furnitureshop-banner-03__feature-text"
      data-attribute="furnitureshop-banner-03__feature-text"
    >
      ${text}
    </span>
  </li>
`;
const contentHtml = `
  <div class="furnitureshop-banner-03 container" data-attribute="furnitureshop-banner-03">
    <header class="furnitureshop-banner-03__header" data-attribute="furnitureshop-banner-03__header">
      <div class="furnitureshop-banner-03__title" data-attribute="furnitureshop-banner-03__title">
        <h2>
          <span style="font-size: 40px"><strong>Ultimate Hydrophobic,</strong></span><br />
          <span style="font-size: 40px"><strong>Leaving Nothing</strong></span>
        </h2>
      </div>
      <div class="furnitureshop-banner-03__heading" data-attribute="furnitureshop-banner-03__heading">
        <img
          class="furnitureshop-banner-03__decor"
          data-attribute="furnitureshop-banner-03__decor"
          src="https://cdn.skyfastimg.com/images/2026/08/20/image-6a86740aab3a65f2691e0790.png?w=500"
          alt=""
        />
        <div
          class="furnitureshop-banner-03__description"
          data-attribute="furnitureshop-banner-03__description"
        >
          <p>Beads roll away carrying dirt and oil,<br />reducing washes for a lasting clean.</p>
        </div>
      </div>
    </header>

    <div class="furnitureshop-banner-03__content" data-attribute="furnitureshop-banner-03__content">
      <div class="furnitureshop-banner-03__media-column">
        <div
          class="furnitureshop-banner-03__media"
          data-attribute="furnitureshop-banner-03__media"
          data-show="true"
          data-media-type="video"
        >
          <video
            class="furnitureshop-banner-03__video"
            data-attribute="furnitureshop-banner-03__video"
            autoplay
            muted
            loop
            playsinline
          >
            <source
              data-attribute="furnitureshop-banner-03__video-source"
              src="https://cdn.shopify.com/videos/c/vp/c81c00939caf4b87a0c629fb422dea87/c81c00939caf4b87a0c629fb422dea87.SD-480p-1.5Mbps-80633429.mp4"
              type="video/mp4"
            />
          </video>
          <div
            class="furnitureshop-banner-03__media-image"
            data-attribute="furnitureshop-banner-03__media-image"
            style="display: none"
          >
            <img data-attribute="furnitureshop-banner-03__media-image-inner" src="" alt="" />
          </div>
        </div>
        <div class="furnitureshop-banner-03__subtext" data-attribute="furnitureshop-banner-03__subtext">
          Lotus-like repelling keeps contaminants away for cleaner paint.
        </div>
      </div>

      <div class="furnitureshop-banner-03__features-column">
        <ul class="furnitureshop-banner-03__features" data-attribute="furnitureshop-banner-03__features">
          ${featureItem('UV Protection')}
          ${featureItem('Anti-Corrosion')}
          ${featureItem('Anti-Aging')}
        </ul>
      </div>
    </div>
  </div>
`;

export default containerFuild(contentHtml, css, {
  backgroundColor: '#05090D',
  textColor: '#FFFFFF',
  backgroundImage: 'https://cdn.skyfastimg.com/images/2026/08/24/image-6a8bc84f89fd5dd2763ad73e.webp?w=1000',
  useBackgroundMobile: true,
  backgroundImageMobile: 'https://cdn.skyfastimg.com/images/2026/08/24/image-6a8bc84b06ff0fabd90e51c9.webp?w=1000',
  topPadding: false,
  bottomPadding: false,
});
